import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

export const translations = {
  nl: {
    nav: { home: 'Thuis', about: 'Over Ons', services: 'Diensten', offers: 'Aanbiedingen', gallery: 'Galerij', contact: 'Contact', book: 'Maak Een Afspraak', login: 'Inloggen', account: 'Mijn Account', admin: 'Admin', logout: 'Uitloggen' },
    hero: { badge: 'LUXE SALON ERVARING', title1: 'Beauty & Style', title2: 'Herdefinieerd', subtitle: 'Waar Elegantie Vakmanschap Ontmoet — Ontdek Uw Ware Schoonheid', cta: 'Maak Een Afspraak', ctaSecondary: 'Bekijk Diensten' },
    common: { book: 'Boek Nu', save: 'Bespaar', from: 'vanaf', min: 'min', loading: 'Laden...', close: 'Sluiten', duration: 'Duur', price: 'Prijs', savings: 'Besparing', with: 'met', all: 'Alles', featured: 'Uitgelicht', new: 'Nieuw', bestseller: 'Bestseller' },
    langModal: { title: 'Kies Uw Taal', subtitle: 'Choose your language / Choisissez votre langue' },
    promo: { title: 'Bingo Beauty Deals', subtitle: 'Ontdek onze exclusieve pakketten', cta: 'Bekijk Aanbiedingen', close: 'Sluiten' },
    services: {
      pageTitle: 'Onze Diensten',
      pageSubtitle: 'Onze Complete Diensten & Prijzen',
      forAppointment: 'Voor Een Afspraak',
      bookNow: 'Boek Nu',
    },
    offers: {
      pageTitle: 'Bingo Beauty Deals',
      pageSubtitle: 'Onze zorgvuldig samengestelde pakketten combineren favoriete diensten voor uitzonderlijke waarde.',
      exclusive: 'EXCLUSIEVE PAKKETTEN',
      services: 'Diensten',
      staff: 'Stylist',
      bookThisDeal: 'Boek Deze Deal',
    },
    about: {
      title: 'Over 4AN Hair & Beauty Studio',
      welcome: 'Welkom bij 4AN Hair & Beauty Studio! We zijn verheugd u te mogen ontvangen in het Nederlands, Frans en Engels.',
      nameMeaning: 'Wat betekent onze naam? Het verhaal achter "4AN"',
      nameStory: 'Veel klanten vragen ons naar het verhaal achter onze naam. 4AN staat voor het hart en de ziel van ons huis: 4 A\'s en 1 N.',
      familyStory: 'Onze familie bestaat uit Anoop (mijn echtgenoot), onze drie prachtige dochters — Aadya, Anudhi en Aaramya — en mijzelf, Nidhi (oprichter en hoofdstylist). Samen brengen we diezelfde warmte, zorg en toewijding elke dag in onze salon.',
      wordFromNidhi: 'Een klein woordje van Nidhi',
      babyStory: 'Ons jongste familielid, de kleine Aaramya, is geboren op 29 juni! Omdat ze nog heel klein is, gaan moederplichten soms voor. Hoewel we altijd ons uiterste best doen om elke afspraak perfect te laten verlopen, kan er af en toe een korte vertraging zijn als de kleine Aaramya honger heeft tijdens uw bezoek.',
      thanks: 'We danken u uit de grond van ons hart voor uw begrip, geduld en vriendelijkheid terwijl we het runnen van een luxe salon combineren met de zorg voor onze pasgeborene. We kijken ernaar uit u te verwennen en u thuis te laten voelen!',
      values: 'Onze Waarden',
    },
    booking: {
      pageTitle: 'Boek Uw Afspraak',
      subtitle: 'Vul onderstaande gegevens in om te boeken',
      step1: '1. Selecteer Diensten',
      step2: '2. Kies Uw Stylist',
      step3: '3. Kies Datum & Tijd',
      step4: '4. Uw Gegevens',
      step5: '5. Toestemming & Betaling',
      selectStaff: 'Selecteer een stylist...',
      name: 'Naam',
      email: 'Email',
      phone: 'Telefoon',
      date: 'Datum',
      time: 'Tijd',
      notes: 'Opmerkingen (optioneel)',
      notesPlaceholder: 'Bijv. allergieën, voorkeuren...',
      privacyText: 'Ik ga akkoord met het',
      privacyPolicy: 'privacybeleid',
      andThe: 'en de',
      termsConditions: 'algemene voorwaarden',
      marketingText: 'Ik wil graag promotionele aanbiedingen en nieuws ontvangen via email. (optioneel)',
      paymentMethod: 'Betaalmethode',
      paySalon: 'Betaal in de salon (contant of kaart)',
      payBancontact: 'Bancontact / Payconiq (online)',
      payCard: 'Visa / MasterCard (online)',
      summary: 'Samenvatting',
      totalDuration: 'Totale duur',
      totalPrice: 'Totale prijs',
      submit: 'Bevestig Boeking',
      submitting: 'Bezig met boeken...',
      confirmed: 'Boeking Bevestigd!',
      confirmedText: 'U ontvangt binnenkort een bevestigingsmail met alle details.',
      redirecting: 'U wordt doorgestuurd naar uw account...',
      requiredPrivacy: 'U moet akkoord gaan met het privacybeleid.',
      invalidEmail: 'Ongeldig e-mailadres.',
      invalidPhone: 'Ongeldig telefoonnummer.',
    },
    contact: {
      pageTitle: 'Contact',
      pageSubtitle: 'Heeft u vragen of wilt u een afspraak maken? Neem contact met ons op.',
      visitUs: 'Bezoek Ons',
      address: 'Adres',
      phone: 'Telefoon / WhatsApp',
      email: 'E-mail',
      hours: 'Openingstijden',
      hoursDetail: '7 dagen per week open — Woensdag tot 12:00',
      sendMessage: 'Stuur Een Bericht',
      name: 'Naam',
      message: 'Bericht',
      messagePlaceholder: 'Uw bericht...',
      send: 'Verstuur Bericht',
      sending: 'Bezig met verzenden...',
      thanks: 'Bedankt voor uw bericht!',
      willContact: 'We nemen zo snel mogelijk contact met u op.',
    },
    footer: {
      quickLinks: 'Snelle Links',
      openHours: '7 dagen per week open',
      wednesday: 'Woensdag tot 12:00',
      rights: 'Alle rechten voorbehouden',
    }
  },
  en: {
    nav: { home: 'Home', about: 'About', services: 'Services', offers: 'Offers', gallery: 'Gallery', contact: 'Contact', book: 'Book Appointment', login: 'Login', account: 'My Account', admin: 'Admin', logout: 'Logout' },
    hero: { badge: 'LUXURY SALON EXPERIENCE', title1: 'Beauty & Style', title2: 'Redefined', subtitle: 'Where Elegance Meets Expertise — Reveal Your True Beauty', cta: 'Book Appointment', ctaSecondary: 'View Services' },
    common: { book: 'Book Now', save: 'Save', from: 'from', min: 'min', loading: 'Loading...', close: 'Close', duration: 'Duration', price: 'Price', savings: 'Savings', with: 'with', all: 'All', featured: 'Featured', new: 'New', bestseller: 'Bestseller' },
    langModal: { title: 'Choose Your Language', subtitle: 'Kies uw taal / Choisissez votre langue' },
    promo: { title: 'Bingo Beauty Deals', subtitle: 'Discover our exclusive packages', cta: 'View Offers', close: 'Close' },
    services: {
      pageTitle: 'Our Services',
      pageSubtitle: 'Our Complete Services & Prices',
      forAppointment: 'For an Appointment',
      bookNow: 'Book Now',
    },
    offers: {
      pageTitle: 'Bingo Beauty Deals',
      pageSubtitle: 'Our carefully curated packages combine favorite services for exceptional value.',
      exclusive: 'EXCLUSIVE PACKAGES',
      services: 'Services',
      staff: 'Stylist',
      bookThisDeal: 'Book This Deal',
    },
    about: {
      title: 'About 4AN Hair & Beauty Studio',
      welcome: 'Welcome to 4AN Hair & Beauty Studio! We are delighted to welcome you in English, Dutch, and French.',
      nameMeaning: 'What does our name mean? The story behind "4AN"',
      nameStory: 'Many clients ask us about the story behind our name. 4AN represents the heart and soul of our home: 4 A\'s and 1 N.',
      familyStory: 'Our family consists of Anoop (my husband), our three beautiful daughters — Aadya, Anudhi and Aaramya — and myself, Nidhi (founder and lead stylist). Together, we bring that same warmth, care, and dedication into our salon every single day.',
      wordFromNidhi: 'A Word from Nidhi',
      babyStory: 'The newest addition to our family, little Aaramya, was born on June 29! As she is still very tiny, mommy-duty sometimes takes over. Even though we always try our best to keep every appointment running smoothly, there may occasionally be a brief delay if little Aaramya gets hungry during your visit.',
      thanks: 'We thank you from the bottom of our hearts for your understanding, patience, and kindness while we balance running a luxury salon with caring for our newborn. We look forward to pampering you and making you feel right at home!',
      values: 'Our Values',
    },
    booking: {
      pageTitle: 'Book Your Appointment',
      subtitle: 'Fill in the details below to book',
      step1: '1. Select Services',
      step2: '2. Choose Your Stylist',
      step3: '3. Pick Date & Time',
      step4: '4. Your Details',
      step5: '5. Consent & Payment',
      selectStaff: 'Select a stylist...',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      date: 'Date',
      time: 'Time',
      notes: 'Notes (optional)',
      notesPlaceholder: 'e.g. allergies, preferences...',
      privacyText: 'I agree to the',
      privacyPolicy: 'privacy policy',
      andThe: 'and the',
      termsConditions: 'terms and conditions',
      marketingText: 'I would like to receive promotional offers and news via email. (optional)',
      paymentMethod: 'Payment Method',
      paySalon: 'Pay at the salon (cash or card)',
      payBancontact: 'Bancontact / Payconiq (online)',
      payCard: 'Visa / MasterCard (online)',
      summary: 'Summary',
      totalDuration: 'Total duration',
      totalPrice: 'Total price',
      submit: 'Confirm Booking',
      submitting: 'Booking...',
      confirmed: 'Booking Confirmed!',
      confirmedText: 'You will receive a confirmation email shortly with all the details.',
      redirecting: 'Redirecting to your account...',
      requiredPrivacy: 'You must agree to the privacy policy.',
      invalidEmail: 'Invalid email address.',
      invalidPhone: 'Invalid phone number.',
    },
    contact: {
      pageTitle: 'Contact',
      pageSubtitle: 'Have questions or want to book an appointment? Get in touch.',
      visitUs: 'Visit Us',
      address: 'Address',
      phone: 'Phone / WhatsApp',
      email: 'Email',
      hours: 'Opening Hours',
      hoursDetail: '7 days a week — Wednesday until 12:00',
      sendMessage: 'Send a Message',
      name: 'Name',
      message: 'Message',
      messagePlaceholder: 'Your message...',
      send: 'Send Message',
      sending: 'Sending...',
      thanks: 'Thank you for your message!',
      willContact: 'We will contact you as soon as possible.',
    },
    footer: {
      quickLinks: 'Quick Links',
      openHours: 'Open 7 days a week',
      wednesday: 'Wednesday until 12:00',
      rights: 'All rights reserved',
    }
  },
  fr: {
    nav: { home: 'Accueil', about: 'À Propos', services: 'Services', offers: 'Offres', gallery: 'Galerie', contact: 'Contact', book: 'Prendre RDV', login: 'Connexion', account: 'Mon Compte', admin: 'Admin', logout: 'Déconnexion' },
    hero: { badge: 'EXPÉRIENCE SALON DE LUXE', title1: 'Beauté & Style', title2: 'Redéfinis', subtitle: "Où l'élégance rencontre l'expertise — Révélez votre vraie beauté", cta: 'Prendre Rendez-vous', ctaSecondary: 'Voir les Services' },
    common: { book: 'Réserver', save: 'Économisez', from: 'à partir de', min: 'min', loading: 'Chargement...', close: 'Fermer', duration: 'Durée', price: 'Prix', savings: 'Économies', with: 'avec', all: 'Tous', featured: 'Vedette', new: 'Nouveau', bestseller: 'Meilleure vente' },
    langModal: { title: 'Choisissez Votre Langue', subtitle: 'Kies uw taal / Choose your language' },
    promo: { title: 'Offres Bingo Beauté', subtitle: 'Découvrez nos forfaits exclusifs', cta: 'Voir les Offres', close: 'Fermer' },
    services: {
      pageTitle: 'Nos Services',
      pageSubtitle: 'Nos Services & Prix Complets',
      forAppointment: 'Pour un Rendez-vous',
      bookNow: 'Réserver',
    },
    offers: {
      pageTitle: 'Offres Bingo Beauté',
      pageSubtitle: 'Nos forfaits soigneusement composés combinent des services favoris pour une valeur exceptionnelle.',
      exclusive: 'FORFAITS EXCLUSIFS',
      services: 'Services',
      staff: 'Styliste',
      bookThisDeal: 'Réserver Cette Offre',
    },
    about: {
      title: 'À Propos de 4AN Hair & Beauty Studio',
      welcome: 'Bienvenue chez 4AN Hair & Beauty Studio ! Nous sommes ravis de vous accueillir en français, néerlandais et anglais.',
      nameMeaning: 'Que signifie notre nom ? L\'histoire derrière "4AN"',
      nameStory: 'Beaucoup de nos clients nous demandent l\'histoire derrière notre nom. 4AN représente le cœur et l\'âme de notre foyer : 4 A et 1 N.',
      familyStory: 'Notre famille se compose d\'Anoop (mon mari), de nos trois magnifiques filles — Aadya, Anudhi et Aaramya — et de moi-même, Nidhi (fondatrice et styliste principale). Ensemble, nous apportons cette même chaleur, cette attention et ce dévouement dans notre salon chaque jour.',
      wordFromNidhi: 'Un petit mot de Nidhi',
      babyStory: 'Le plus récent membre de notre famille, la petite Aaramya, est née le 29 juin ! Comme elle est encore très petite, les devoirs de maman prennent parfois le dessus. Même si nous faisons toujours tout notre possible pour que chaque rendez-vous se déroule parfaitement, il peut y avoir occasionnellement un bref délai si la petite Aaramya a faim pendant votre visite.',
      thanks: 'Nous vous remercions du fond du cœur pour votre compréhension, votre patience et votre bienveillance alors que nous concilions la gestion d\'un salon de luxe et les soins de notre nouveau-né. Nous avons hâte de vous chouchouter et de vous faire sentir comme chez vous !',
      values: 'Nos Valeurs',
    },
    booking: {
      pageTitle: 'Prendre Rendez-vous',
      subtitle: 'Remplissez les détails ci-dessous pour réserver',
      step1: '1. Sélectionnez les Services',
      step2: '2. Choisissez Votre Styliste',
      step3: '3. Choisissez Date & Heure',
      step4: '4. Vos Coordonnées',
      step5: '5. Consentement & Paiement',
      selectStaff: 'Sélectionnez un styliste...',
      name: 'Nom',
      email: 'Email',
      phone: 'Téléphone',
      date: 'Date',
      time: 'Heure',
      notes: 'Notes (optionnel)',
      notesPlaceholder: 'ex. allergies, préférences...',
      privacyText: 'J\'accepte la',
      privacyPolicy: 'politique de confidentialité',
      andThe: 'et les',
      termsConditions: 'conditions générales',
      marketingText: 'Je souhaite recevoir des offres promotionnelles et des actualités par email. (optionnel)',
      paymentMethod: 'Méthode de Paiement',
      paySalon: 'Payer au salon (espèces ou carte)',
      payBancontact: 'Bancontact / Payconiq (en ligne)',
      payCard: 'Visa / MasterCard (en ligne)',
      summary: 'Récapitulatif',
      totalDuration: 'Durée totale',
      totalPrice: 'Prix total',
      submit: 'Confirmer la Réservation',
      submitting: 'Réservation...',
      confirmed: 'Réservation Confirmée !',
      confirmedText: 'Vous recevrez sous peu un email de confirmation avec tous les détails.',
      redirecting: 'Redirection vers votre compte...',
      requiredPrivacy: 'Vous devez accepter la politique de confidentialité.',
      invalidEmail: 'Adresse email invalide.',
      invalidPhone: 'Numéro de téléphone invalide.',
    },
    contact: {
      pageTitle: 'Contact',
      pageSubtitle: 'Des questions ou envie de réserver ? Contactez-nous.',
      visitUs: 'Visitez-nous',
      address: 'Adresse',
      phone: 'Téléphone / WhatsApp',
      email: 'Email',
      hours: 'Horaires d\'ouverture',
      hoursDetail: '7 jours sur 7 — Mercredi jusqu\'à 12:00',
      sendMessage: 'Envoyer un Message',
      name: 'Nom',
      message: 'Message',
      messagePlaceholder: 'Votre message...',
      send: 'Envoyer le Message',
      sending: 'Envoi...',
      thanks: 'Merci pour votre message !',
      willContact: 'Nous vous contacterons dès que possible.',
    },
    footer: {
      quickLinks: 'Liens Rapides',
      openHours: '7 jours sur 7',
      wednesday: 'Mercredi jusqu\'à 12:00',
      rights: 'Tous droits réservés',
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('4an_lang') || null);

  useEffect(() => {
    if (lang) localStorage.setItem('4an_lang', lang);
  }, [lang]);

  const currentLang = lang || 'nl';
  const t = translations[currentLang];

  // Helper: get localized field from a document (service, category, promo, staff)
  // Falls back: try lang → nl → en → fallback default field
  const localize = (obj, field) => {
    if (!obj) return '';
    return obj[`${field}_${currentLang}`] || obj[`${field}_nl`] || obj[`${field}_en`] || obj[field] || '';
  };

  return (
    <LanguageContext.Provider value={{ lang: currentLang, rawLang: lang, setLang, t, localize }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
